import React from "react";
import HeroSection from "./HeroSection";
import ProductCard from "./ProductCard";

const HomePage = ({ products, onProductClick }) => {
  return (
    <div>
      <HeroSection featuredProducts={products && Array.isArray(products) ? products.slice(0, 4) : []} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h2 className="text-3xl font-bold text-gray-900 mb-8">Featured Products</h2>
        {!products || !Array.isArray(products) || products.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-gray-600">No products found. Please check the console for errors.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {products.slice(0, 8).map(product => (
              <ProductCard key={product._id || product.id} product={product} onProductClick={onProductClick} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default HomePage;
